import { Stack } from "@mui/material";
import React from "react";
import shilat from "../assets/shilat.png";
import dampezeshki from "../assets/dampezeshki.png";
import fatahush from "../assets/fatahush.png";

const logoList = [
  { src: fatahush, alt: "شرکت فناوری اطلاعات فراهوش کام" },
  //{ src: dampezeshki, alt: "سازمان دامپزشکی کشور" },
  //{ src: shilat, alt: "سازمان شیلات ایران" },
];

const FooterLogos = () => {
  return (
    <Stack flexDirection={"row"} justifyContent={"center"} alignContent={"center"} gap={2}>
      {logoList.map((item, index) => (
        <img src={item.src} alt={item.alt} width={110} height={100} key={index} />
      ))}
    </Stack>
  );
};

export default FooterLogos;
